import { getRequest } from 'utils/axios'

// eslint-disable-next-line import/prefer-default-export
export const fetchClubAgeClasses = (clubUuid) => {
  const url = `v2/clubs/${clubUuid}/age-classes`

  return getRequest(url)
}
